import React from "react";
import Icon from "components/AppIcon";


const SECTORS = ["All", "Tech", "Retail", "Manufacturing", "Financial", "Black Market"];
const SORT_OPTIONS = [
  { value: "all", label: "All Stocks" },
  { value: "gainers", label: "Top Gainers" },
  { value: "losers", label: "Top Losers" },
  { value: "volume", label: "High Volume" },
];

const FilterBar = ({ search, onSearch, sector, onSector, filter, onFilter }) => {
  return (
    <div className="flex flex-col md:flex-row gap-3 p-4 border-b border-border">
      {/* Search */}
      <div className="relative flex-1 min-w-0">
        <Icon name="Search" size={16} color="var(--color-muted-foreground)" className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input
          type="text"
          value={search}
          onChange={e => onSearch(e?.target?.value)}
          placeholder="Search stocks by name or ticker..."
          className="w-full pl-9 pr-4 py-2 bg-secondary border border-border rounded-lg font-body text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/30 transition-all"
        />
      </div>
      {/* Sector Filter */}
      <div className="flex items-center gap-2 overflow-x-auto pb-1 md:pb-0 flex-shrink-0">
        {SECTORS?.map(s => (
          <button key={s} onClick={() => onSector(s)}
            className={`flex-shrink-0 px-3 py-1.5 rounded-lg font-caption text-xs font-medium transition-all duration-150 whitespace-nowrap ${sector === s ? "bg-primary/20 text-primary border border-primary/40" : "bg-secondary text-muted-foreground border border-border hover:border-primary/30 hover:text-foreground"}`}>
            {s}
          </button>
        ))}
      </div>
      {/* Sort/Filter Dropdown */}
      <div className="flex gap-2 flex-shrink-0">
        {SORT_OPTIONS?.map(opt => (
          <button key={opt?.value} onClick={() => onFilter(opt?.value)}
            className={`px-3 py-1.5 rounded-lg font-caption text-xs font-medium transition-all duration-150 whitespace-nowrap ${filter === opt?.value ? "bg-accent/20 text-accent border border-accent/40" : "bg-secondary text-muted-foreground border border-border hover:border-accent/30 hover:text-foreground"}`}>
            {opt?.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterBar;